import 'css-chunk:src/components/modal/modal-component.module.scss';export default {
  "modal-component": "modal-component_modal-component__c33Dx",
  "modal": "modal-component_modal__edWtj",
  "header": "modal-component_header__O7q-7",
  "header-contents": "modal-component_header-contents__cqfvF",
  "close-icon": "modal-component_close-icon__TnkR6",
  "footer": "modal-component_footer__gXgFV",
  "footer-contents": "modal-component_footer-contents__EiDUv",
  "no-footer": "modal-component_no-footer__ViH9L",
  "scroll-container-footer": "modal-component_scroll-container-footer__xVzKk",
  "white-background": "modal-component_white-background__-vQSN",
  "scroll-container-no-footer": "modal-component_scroll-container-no-footer__gvBS-",
  "overlay": "modal-component_overlay__t1hpC",
  "hide-overlay": "modal-component_hide-overlay__RuQRi",
  "no-scroll": "modal-component_no-scroll__3cb4N",
  "centred": "modal-component_centred__EGZv-",
  "mobile-header-border": "modal-component_mobile-header-border__O0kOo",
  "small": "modal-component_small__VXWxQ",
  "full": "modal-component_full__XNiyd",
  "slidedown": "modal-component_slidedown__-cAET",
  "full-slidedown": "modal-component_full-slidedown__vEu88",
  "slideup": "modal-component_slideup__MnPl0",
  "full-slideup": "modal-component_full-slideup__tUkAF",
  "fullscreen": "modal-component_fullscreen__XA3Ri",
  "show-footer-gte-tablet": "modal-component_show-footer-gte-tablet__yd-lj",
  "normal": "modal-component_normal__PFyet",
  "sidebar": "modal-component_sidebar__eUAQY",
  "header-border": "modal-component_header-border__UXNZv",
  "sidebar-footer": "modal-component_sidebar-footer__skz2B",
  "sidebar-tablet": "modal-component_sidebar-tablet__tlF5c",
  "normal-tablet": "modal-component_normal-tablet__e9Lku"
};